import { colors } from '@creditornot/cb-ingredients';
import { MenuItemGroup } from '@creditornot/cb-menu';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background-color: ${colors.wolt4};
`;

export const TagsContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
`;

export const ErrorContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const PopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 8px;
`;

export const ActionGroup = styled(MenuItemGroup)`
  & + & {
    margin-block-start: 16px;
  }
`;
